"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../shared/hooks");
const navigation_1 = require("../organisms/navigation");
const sidebarWithMenu_1 = __importDefault(require("../organisms/sidebar/sidebarWithMenu"));
const resources_1 = require("../resources");
const NavigationTopMD_1 = require("../organisms/navigation/NavigationTopMD");
const Layout = styled_components_1.default.section `
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.silverLighten40};
  padding-bottom: ${({ theme, withBottomSpace }) => withBottomSpace ? theme.spacings.m : ""};
  position: relative;

  [data-component="notification"] {
    position: absolute;
    left: 0;
    top: 49px;
    width: 100%;
    z-index: 1000;
  }

  [data-svg="logo"] {
    height: 2rem;
    width: auto;
  }

  nav {
    padding: ${({ theme }) => theme.spacings.m};
  }
`;
const TopNavigation = (0, styled_components_1.default)(NavigationTopMD_1.TopNavigationMD) `
  position: sticky;
  top: 0;
  z-index: 10;
`;
const NavigationMobile = (0, styled_components_1.default)(navigation_1.NavigationMobile) `
  position: sticky;
  top: 0;
  z-index: 10;
`;
const Page = styled_components_1.default.section `
  padding: 0 ${({ theme }) => theme.spacings.xl};
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: 0;
  }
`;
const LayoutFC = ({ title, menu, children, logoLink, withBottomSpace }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    const [isSidebarOpen, setIsSidebarOpen] = (0, react_1.useState)(false);
    // TODO: copy and change navigation instance
    return ((0, jsx_runtime_1.jsxs)(Layout, { withBottomSpace: withBottomSpace, children: [!isMobile && ((0, jsx_runtime_1.jsx)(TopNavigation, { isLogged: false, logoSVG: (0, jsx_runtime_1.jsx)(resources_1.LogoCL_MD, {}, void 0), dropdown: { title: menu.title, options: menu.options }, logoLink: logoLink }, void 0)), isMobile && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(NavigationMobile, { title: title || "", onMenuClick: () => {
                            setIsSidebarOpen((prev) => {
                                return !prev;
                            });
                        } }, void 0), (0, jsx_runtime_1.jsx)(sidebarWithMenu_1.default, { open: isSidebarOpen, menu: menu.options, onClose: () => setIsSidebarOpen(false) }, void 0)] }, void 0)), (0, jsx_runtime_1.jsx)(Page, { children: children }, void 0)] }, void 0));
};
exports.default = LayoutFC;
//# sourceMappingURL=MemberDashboardLayout.js.map